import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10be5a1e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../styles/button.less?vue&type=style&index=0&id=10be5a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be5a1e",
  null
  
)

export default component.exports